<bl-select-modal-base
  [title]="'COMMON.LABELS.MOVE' | translate"
  (closeClick)="dismiss()"
  [showSearchBar]="false"
  [showHeaderBorder]="true"
  class="ion-page"
>
  <p class="color--medium text--sm pb-2">
    {{ "MODALS.MOVE_TO_FOLDER.SUBTITLE" | translate: { name: props.name } }}
  </p>

  <div class="level">
    <ion-button
      *ngIf="path.length > 1"
      class="up"
      fill="clear"
      size="small"
      (click)="up()"
      [attr.aria-label]="'COMMON.LABELS.BACK' | translate"
      [title]="'COMMON.LABELS.BACK' | translate"
    >
      <svg-icon
        slot="icon-only"
        key="arrow-left"
        class="color--dark"
        aria-hidden="true"
      ></svg-icon>
    </ion-button>
    <h2 class="text--base text--medium">{{ here.name }}</h2>
  </div>

  <ion-list lines="none">
    <ion-item
      *ngFor="let folder of folders"
      button
      detail="false"
      [disabled]="folder.id === props.movingFolderId"
      (click)="enter(folder)"
    >
      <svg-icon
        slot="start"
        key="folder"
        aria-hidden="true"
      ></svg-icon>
      <ion-label class="font--base">{{ folder.name }}</ion-label>
      <svg-icon
        slot="end"
        key="caret-down"
        class="open-caret"
        aria-hidden="true"
      ></svg-icon>
    </ion-item>
  </ion-list>
  <p
    *ngIf="folders?.length === 0"
    class="color--medium text--sm"
  >
    {{ "MODALS.MOVE_TO_FOLDER.NO_SUBFOLDERS" | translate }}
  </p>

  <div class="footer">
    <p
      *ngIf="isCurrent"
      class="color--medium text--sm"
    >
      {{ "MODALS.MOVE_TO_FOLDER.ALREADY_HERE" | translate }}
    </p>
    <ion-button
      expand="block"
      [disabled]="isCurrent"
      (click)="move()"
      data-cy="move-confirm"
    >
      {{ "MODALS.MOVE_TO_FOLDER.CONFIRM" | translate: { name: here.name } }}
    </ion-button>
  </div>
</bl-select-modal-base>
